export default __webpack_public_path__ + "static/media/workplace.e46831ac.png";